import React, { Component } from 'react';
import BannerLink from "./Banner-link";
import BusSearch from "./BusSearch";


import SectionLoader from "../../components/loader/SectionLoader";
import { ToastContainer } from 'react-toastify';
import { Container, TabContent, TabPane } from 'reactstrap';

import "./../../assets/images/home_banner.jpg";
import connect from "react-redux/es/connect/connect";


class BannerI extends Component {
    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get('type');
        let tab;

        switch (type) {
            case null:
                tab = '1';
                break;
            case 'bus':
                tab = '2';
                break;
            default:
                tab = '1'
        }

        console.log(type);

        this.state = {
            loading: false,
            hasAlert: false,
            airports: [],
            activeTab: tab,
            activeimg: null
        };
    }

    async componentDidMount() {
        await this.handleRequest();
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                activeimg: "activeimg"
            });
        }
    }
    render() {


        // console.log(new URLSearchParams(window.location.href).get('type'))

        return (
            <div className="banner">
                <img src={"./../../assets/images/home_banner.jpg"} alt="iranroute ticket system" className={"home-back-img " + this.state.activeimg} />
                {!this.state.loading ? <SectionLoader type="spinningBubbles" color="#0ebcf2" /> :
                    <div className="Home-banners-icon-and-tab">
                        <div className="d-flex justify-content-center1 banner-caption w-100">
                            <TabContent activeTab={this.state.activeTab} className='tabcontent-home'>
                                <div className="Home-tabs">
                                    <TabPane tabId="1" className='tabpane-home airplane-search'>
                                        <Container >
                                            <BannerLink airports={this.state.airports} selectedairports={this.props.selectedairports} />
                                        </Container>
                                    </TabPane>
                                    <TabPane tabId="2" className='tabpane-home'>
                                        <Container >
                                            <BusSearch airports={this.state.airports} />
                                        </Container>
                                    </TabPane>

                                </div>

                            </TabContent>
                        </div>
                    </div>
                }
                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>
        );
    }
    async handleRequest() {
        this.setState({ loading: false });
        try {

            let { airports } = this.props;

            this.setState({
                airports
            });

        } catch (e) {
            console.log(e);
        }
        this.setState({ loading: true });
    };
}

const mapStateToProps = (state) => {
    return {
        airports: state.airports,
        selectedairports: state.selectedairports
    }
};
export default connect(mapStateToProps, null)(BannerI)


// WEBPACK FOOTER //
// ./src/components/banner/BannerI.js